import { startGetClientes } from "./clientesActions";
import { verificaLogin } from "./loginActions";
import { startGetProveedores } from "./proveedoresActions";
import { startGetEstadosTodos } from "./reportesActions";
import {
  startGetListas,
  startGetTiposAsistencia,
} from "./tiposAsistenciaActions";

export const startLoadInitial = () => {
  return async (dispatch) => {
    dispatch(verificaLogin());
    dispatch(startGetListas());
    dispatch(startGetTiposAsistencia());
    dispatch(startGetEstadosTodos());

  };
};
